module.exports = __webpack_public_path__ + "static/img/industry.7807c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industry.png
// module id = wfYq
// module chunks = 0